import { Typography } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    active: {
      color: theme.palette.text.secondary
    },
    root: {
      "&$active": {
        background: theme.palette.info.dark,
        color: "#FFFFFF",
        "& .MuiTypography-root": {
          color: "#FFFFFF"
        }
      },
      background: "#E0E0E0",
      color: fade(theme.palette.grey[500], 0.6),
      "& .MuiTypography-root": {
        color: fade(theme.palette.grey[500], 0.6)
      },
      cursor: "pointer",
      display: "inline-block",
      minWidth: 240,
      transition: theme.transitions.duration.short + "ms"
    }
  }),
  { name: "Tab" }
);

interface TabProps<T> {
  children?: React.ReactNode;
  isActive: boolean;
  changeTab: (index: T) => void;
  testId?: string;
}

function Tab<T>(value: T) {
  const Component: React.FC<TabProps<T>> = props => {
    const { children, isActive, changeTab, testId } = props;

    const classes = useStyles(props);

    return (
      <Typography
        component="span"
        data-testid={testId}
        id={testId}
        className={classNames({
          [classes.root]: true,
          [classes.active]: isActive
        })}
        onClick={() => changeTab(value)}
      >
        {children}
      </Typography>
    );
  };

  return Component;
}

export default Tab;
